<template>
  <div class="home-article">
    <nav-header :activeIndex="3" />
    <main class="home-article-content">
      <div class="home-article-content-inner">
        <div class="search">
          <input type="text" v-model="searchVal" placeholder="请输入文章标题或关键字" @keydown="handleKeySearch">
           <div class="icon" @click="handleSearch">
             <Icon type="search" />
           </div>
        </div>
        <section class="home-article-content-inner-content-field">
          <div v-for="(item, index) in field" :key="index" @click="searchField(item.title, index)"
               :class="['home-article-content-inner-content-field-item', index === activeIndex ? 'active' : '']">
            {{item.title}}
          </div>
          <div class="home-article-content-inner-content-field-item" style="opacity: 0">更多专长领域</div>
        </section>
        <article-list :articleList="articleList">
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              prev-text="< 上一页"
              next-text="下一页 >"
              :total="total"
              :page-size="pageSize"
              :current-page="pageIndex"
              hide-on-single-page
              @current-change="handleChange"
            >
            </el-pagination>
          </div>
        </article-list>
      </div>
    </main>
  </div>
</template>

<script>
  import Icon from '@/common-components/icon'
  import ArticleList from '@/common-components/article-list'
  import NavHeader from '@/common-components/nav-header'
  import api from './api'
  export default {
    name: 'home-article',
    components: {
      Icon, ArticleList, NavHeader
    },
    data () {
      return {
        field: [
          {title: '婚姻家庭'},
          {title: '刑事辩护'},
          {title: '合同纠纷'},
          {title: '债权债务'},
          {title: '房产纠纷'}
        ],
        activeIndex: '',
        total: 40,
        pageIndex: 1,
        pageSize: 10,
        searchVal: '',
        type: '',
        articleList: []
      }
    },
    mounted () {
      this.type = this.$route.query.type || ''
      this.getArticleList()
    },
    methods: {
      // 路由跳转
      navigatorRoute (path) {
        let router = this.$router.resolve({
          name: path,
          params: {},
          query: {}
        })
        window.open(router.href)
      },
      // 改变页数
      handleChange (val) {
        this.pageIndex = val
        this.getArticleList()
      },
      handleSearch () {
        let quote = this.searchVal.replace(new RegExp('”', 'g'), '')
        let quoteDel = quote.replace(new RegExp('“', 'g'), '')
        this.searchVal = quoteDel.replace(/\\/g, '')
        this.pageIndex = 1
        this.getArticleList()
      },
      handleKeySearch (event) {
        let quote = this.searchVal.replace(new RegExp('”', 'g'), '')
        let quoteDel = quote.replace(new RegExp('“', 'g'), '')
        this.searchVal = quoteDel.replace(/\\/g, '')
        let e = event || window.event
        if (e && e.keyCode === 13) { // enter 键
          this.pageIndex = 1
          this.getArticleList()
        }
      },
      // 获取文章列表
      getArticleList () {
        let params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          title: this.searchVal.slice(0, 100),
          type: this.type
        }
        api.getArticleList(params).then(res => {
          this.total = res.data.data.total
          this.articleList = res.data.data.list
        })
      },
      // 选择擅长领域
      searchField (title, index) {
        this.activeIndex = index
        this.type = title
        this.pageIndex = 1
        this.getArticleList()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .home-article {
    &-content {
      margin-top .72rem
      background #f7f7f7
      &-inner {
        width: 9.4rem
        margin 0 auto
        padding .48rem 0 1rem 0
        .search {
          width 100%
          height: .48rem
          background #fff
          padding 0 .2rem
          line-height: .48rem
          display flex
          border-radius .04rem
          border: solid .01rem #e1e1e1
          input {
            flex 1
            font-size: .16rem
          }
          input::-webkit-input-placeholder{
            color: #a9a9a9
          }
          .icon {
            font-size: .24rem
            color: #a9a9a9
            position relative
            top .03rem
          }
        }
        &-content-field {
          display flex
          justify-content space-around
          flex-wrap wrap
          &-item {
            width: 3rem;
            height: .48rem;
            flex-shrink 0
            border-radius: .04rem;
            background-color: #ffffff;
            text-align: center;
            color: #1d1b1b;
            line-height .48rem
            margin-top .2rem
            font-size: .16rem
            cursor pointer
          }
          .active {
            color: #ed6c00;
          }
        }
        .pagination {
          width: 100%
          margin-top .62rem
          text-align center
        }
      }
    }
  }
</style>

<style lang="stylus">
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    background #f7f7f7
    border-radius 50%
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #fa8919
  }
</style>



// WEBPACK FOOTER //
// src/components/article/article.vue